import React from 'react';

import Thumb from '../img/creative-developer.png';
import Img from '../img/creative-developer2.png';

const CreativeDeveloper = {
    id: 13, permalink: "creative-developer", thumb: Thumb, title: "Creative Developer", category: "Web Template", categoryURL: "webtemplate", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://creative-developer-w.web.app/", sourceTxt: "", sourceURL: "", description: <>
        <h3 className="mbSmall">Creative Developer is a Multi Purpose Portfolio Web Template.</h3>
        <p>&nbsp;</p>

        <h5>Main Feature:</h5>
        <ul>
            <li>Design With HTML5, CSS3, Sass &amp; JavaScript</li>
            <li>Google Web Font Include</li>
            <li>Fully Responsive Web Template</li>
            <li>11 Page Included</li>
            <li>Responsive and Sticky Menu</li>
            <li>Text Slider in Hero Section</li>
            <li>Linear Gradient Hover Skew Heading</li>
            <li>Play Photo Composition by hover in About Section/Page</li>
            <li>Responsive Portfolio Filter with Isotope</li>
            <li>Portfolio Summary in "Popup"</li>
            <li>Portfolio Project View in "Preview Popup" with Responsive check</li>
            <li>Testimonial Image Caption in hover</li>
            <li>Blog Section in Home Page</li>
            <li>Contact Form validation by HTML CSS</li>
            <li>Blog, Single Post and Pages have 2 type Pages Sidebar and Fullwidth</li>
            <li>404 Page Included</li>
        </ul>
    </>
};

export default CreativeDeveloper;